import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
import { SiteHeader } from '../components/SiteHeader';
import { AppFooter } from '../components/AppFooter';
import { useScreenInit } from '../useScreenInit';
export function NotFound() {
  useScreenInit('NotFound');
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-1088">
      <Helmet data-id="element-1089">
        <title data-id="element-1090">Page Not Found | Affordable Medical Tourism</title>
        <meta name="robots" content="noindex, nofollow" data-id="element-1091" />
      </Helmet>

      <SiteHeader brand="Affordable Medical Tourism" links={[{
      label: 'Procedures',
      href: '/procedures'
    }, {
      label: 'How it works',
      href: '/how-it-works'
    }, {
      label: 'Destinations',
      href: '/destinations'
    }, {
      label: 'FAQ',
      href: '/faq'
    }]} contactCtaLabel="Get a free quote" onContactCta={() => window.location.href = '/contact'} data-id="element-1092" />

      <main className="flex-1 flex flex-col items-center justify-center p-6 text-center" data-id="element-1093">
        <h1 className="text-6xl font-bold text-slate-900 mb-4" data-id="element-1094">404</h1>
        <h2 className="text-2xl font-semibold text-slate-700 mb-6" data-id="element-1095">
          Page Not Found
        </h2>
        <p className="text-slate-500 max-w-md mb-8" data-id="element-1096">
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </p>
        <Link to="/" data-id="element-1097">
          <Button size="lg" data-id="element-1098">Return to Homepage</Button>
        </Link>
      </main>

      <AppFooter data-id="element-1099" />
    </div>;
}